<adapt-render-zone-map [zoneContentContainerTemplate]="expandedZoneContentTemplate"
                       [globalZoneContentContainerTemplate]="expandedGlobalZoneContentTemplate"
                       [showGlobalZoneLocation]="showGlobalZoneLocation"
                       [globalZoneLocationLabel]="globalZoneLocationLabel"></adapt-render-zone-map>

<ng-template #expandedZoneContentTemplate
             let-zone>
    <div class="zone-content-container"
         [style.--zone-background-colour]="zoneBackgroundColour(zone)"
         [ngClass]="zoneContentClass(zone)">
        @if (zone === Zone.EconomicEngine) {
            <ng-container *ngTemplateOutlet="economicEngineTemplate"></ng-container>
        } @else {
            <div class="zone-content">
                <ng-container [ngTemplateOutlet]="expandedZoneLocationTemplate"
                              [ngTemplateOutletContext]="{zone: zone}"></ng-container>
            </div>
        }
    </div>
</ng-template>

<ng-template #economicEngineTemplate>
    @if (showResearchAndDevelopment) {
        <div class="research-and-development-container"
             [class.show-on-left]="showOnLeft"
             data-test="zone-ResearchAndDevelopment">
            <div class="research-zone-name-container">
                <div class="research-zone-name">
                    <adapt-zone-label [applyZoneColor]="false"
                                      [zone]="Zone.ResearchAndDevelopment"></adapt-zone-label>
                </div>
            </div>
            <div class="research-zone-content">
                <ng-container [ngTemplateOutlet]="expandedZoneLocationTemplate"
                              [ngTemplateOutletContext]="{zone: Zone.ResearchAndDevelopment}"></ng-container>
            </div>
        </div>
    }

    <div class="economic-engine-sub-container">
        @if (showEconomicEngine) {
            <ng-container [ngTemplateOutlet]="expandedZoneLocationTemplate"
                          [ngTemplateOutletContext]="{zone: Zone.EconomicEngine}"></ng-container>
        }
    </div>
</ng-template>

<ng-template #expandedGlobalZoneContentTemplate>
    <div class="zone-content-container mx-0 my-1">
        <div class="zone-content">
            <ng-container [ngTemplateOutlet]="globalZoneLocationTemplate"></ng-container>
        </div>
    </div>
</ng-template>
